import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\ItemsImportController::__invoke
* @see app/Http/Controllers/Item/ItemsImportController.php
* @route '/api/item/items-import'
*/
const ItemsImportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ItemsImportController.url(options),
    method: 'post',
})

ItemsImportController.definition = {
    methods: ["post"],
    url: '/api/item/items-import',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\ItemsImportController::__invoke
* @see app/Http/Controllers/Item/ItemsImportController.php
* @route '/api/item/items-import'
*/
ItemsImportController.url = (options?: RouteQueryOptions) => {
    return ItemsImportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\ItemsImportController::__invoke
* @see app/Http/Controllers/Item/ItemsImportController.php
* @route '/api/item/items-import'
*/
ItemsImportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ItemsImportController.url(options),
    method: 'post',
})

export default ItemsImportController